<template>
  <Page title="Penerimaan SPM" :sidebar="true">
    <Sidebar :value.sync="penerimaan" />
    <div style="padding:20px; background:white;" class="form-inline">
      <Select
        label="Jenis SPM"
        :value.sync="form.SPMID"
        dbref="DOC.SelJenisSPM"
        placeholder="Pilih..."
      >
      </Select>
      <Input label="No SPM" :value.sync="form.NoDPA" width="400px" />
      <DatePicker label="Tanggal SPM" :value.sync="form.TglDPA" />
      <Input label="Nilai SPM" :value.sync="form.NilaiTermin" type="number" />
      <Select
        label="Bidang/Balai Pengirim"
        :value.sync="form.BalaiID"
        dbref="MST.SelBalai"
        placeholder="Pilih..."
        width="400px"
      >
      </Select>
      <Search
        label="Kontrak Terkait"
        :value.sync="form.KontrakID"
        :text="form.NamaPaket"
        dbref="DOC_SelPenerimaanKontrak"
        placeholder="Cari..."
        width="400px"
      >
      </Search>
      <TextArea
        label="Uraian Pembayaran"
        :value.sync="form.Keterangan"
        width="400px"
        style="min-height: 100px;"
      >
      </TextArea>
      <Input
        type="text"
        label="Penerima Pembayaran"
        width="400px"
        :value.sync="form.Penerima"
      />
      <DatePicker label="Tanggal Penerimaan" :value.sync="form.TglPenerimaan" />
      <br />
      <br />
      <div style="width: 700px; display:flex;">
        <v-btn color="primary" @click="Save">
          SIMPAN
        </v-btn>
        <v-btn text color="primary" @click="Print">
          TANDA TERIMA
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="Delete">
          HAPUS
        </v-btn>
      </div>
    </div>
    <penerimaan-print :form="form" />
  </Page>
</template>
<script>
import DatePicker from '../../components/Forms/DatePicker.vue'
import PenerimaanPrint from './PenerimaanPrint.vue'
import Sidebar from './SideBar'
export default {
  components: {
    Sidebar,
    DatePicker,
    PenerimaanPrint,
  },
  data: () => ({
    form: {},
    penerimaan: {},
  }),
  watch: {
    penerimaan(val) {
      if (val) this.Populate(val.PenerimaanID)
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.Populate(this.$route.params.id)
    }
  },
  methods: {
    async Populate(id) {
      let res = await this.$api.call('DOC.SelPenerimaan', {
        PenerimaanID: id,
      })
      if (res.data && res.data.length) {
        this.form = res.data[0]
      }
    },
    async Save() {
      await this.$api.call('DOC.SavPenerimaan', this.form)
    },
    async Delete() {
      if (!confirm('Yakin Menghapus?')) return

      await this.$api.call('DOC.DelPenerimaan', {
        PenerimaanID: this.form.PenerimaanID,
      })
    },
    Print() {
      var divContents = document.getElementById('print-template').innerHTML
      let style = `<style>
        @media print {
          body {
            width: 21cm;
            height: 29.7cm;
            margin: 30mm 45mm 30mm 45mm;
            /* change the margins as you want them to be. */
          }
        }
      </style>`
      var a = window.open('', '', '')
      a.document.write('<html>')
      a.document.write('<body>')
      a.document.write(style)
      a.document.write(divContents)
      a.document.write('</body></html>')
      a.document.close()
      a.print()
    },
  },
}
</script>
<style lang="scss">
.page-penerimaan-spm {
  .form-inline {
    .form-label {
      flex: 0 0 180px;
    }
    .ui-datepicker {
      input {
        width: 180px;
      }
    }
  }
}
</style>
